module.exports = __webpack_public_path__ + "2c960215f200067a893692882234d108.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgtdjzb_c.png
// module id = 817
// module chunks = 3